import { createSelector } from 'reselect';
import { TEventHubState } from '../../../../../shared/frontend/scripts/event-hub/store/types';

const eventHubState = (state: any) => state?.eventHub as TEventHubState;

export const eventHubExpansionCollectionsSelector = createSelector(
  eventHubState,
  (state) => state.expansionCollections
);

export const eventHubHubCollectionsSelector = createSelector(eventHubState, (state) => state.hubCollections);

export const eventHubLiveEventSelector = createSelector(eventHubState, (state) => state.liveEvent);

export const eventHubUpcomingEventsSelector = createSelector(eventHubState, (state) => state.upcomingEvents);

export const eventHubActiveEventsSelector = createSelector(eventHubState, (state) => state.activeEvents);

export const eventHubLatestEventSelector = createSelector(eventHubState, (state) => state.latestEvent);

export const eventHubWinningHistorySelector = createSelector(eventHubState, (state) => state.eventsHistory);

export const eventHubNewsSelector = createSelector(eventHubState, (state) => state.news);
